import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { TenantService } from "../services/tenant.service";

@Injectable()
export class CalendarUIService {
  private _viewColumns: { [type: string]: boolean } = null;
  private tenantSettingsUpdatedSubscription;
  private readonly VIEW_COLUMNS_STORAGE_KEY = "calendar.vc";
  public ViewColumns: Subject<{ [type: string]: boolean }>;

  constructor(private _tenantService: TenantService) {
    this.initCalendarGridColumns();
  }

  ngOnDestroy() {
    if (this.tenantSettingsUpdatedSubscription) {
      this.tenantSettingsUpdatedSubscription.unsubscribe();
    }
    this.ViewColumns.complete();
  }

  public setViewColumns(cols: { [type: string]: boolean }) {
    if (Object.keys(cols).length == 0) {
      cols = this.getDefaultColumns();
    }
    for (const [key] of Object.entries(cols)) {
      if (key in this._viewColumns) {
        this._viewColumns[key] = cols[key];
      }
    }
    this.populateViewColumns();
  }
  public async resetToDefaults() {
    this._viewColumns = this.getDefaultColumns();
    const ts = await this._tenantService.getTenantSettings();
    if (ts.UseMediaStartTimestampInScheduler == false) {
      delete this._viewColumns.vitsSom;
    } else {
      this._viewColumns.vitsSom = true;
    }
    this.populateViewColumns();
  }

  private getDefaultColumns() {
    return {
      playout: true,
      itemName: true,
      origin: false,
      mediaId: true,
      comments: false,
      originItemStart: false,
      itemStart: true,
      itemEnd: true,
      itemDuration: true,
      itemSom: true,
      vitsSom: false,
      secEvents: true,
    };
  }

  private initCalendarGridColumns(): void {
    const viewColumnsLocalStorage = localStorage.getItem(
      this.VIEW_COLUMNS_STORAGE_KEY,
    );
    if (viewColumnsLocalStorage) {
      const vc = JSON.parse(viewColumnsLocalStorage);
      if (typeof vc == "object" && Object.keys(vc).length > 0) {
        this._viewColumns = Object.assign(this.getDefaultColumns(), vc);
      }
    }
    if (this._viewColumns == null) {
      this._viewColumns = this.getDefaultColumns() as {
        [type: string]: boolean;
      };
    }
    this.ViewColumns = new BehaviorSubject(this._viewColumns);
    this.tenantSettingsUpdatedSubscription =
      this._tenantService.tenantSettingsUpdated.subscribe(() => {
        (async () => {
          this.checkForColumnsInTenantSettings();
        }).bind(this)();
      });
  }

  private async checkForColumnsInTenantSettings() {
    const ts = await this._tenantService.getTenantSettings();
    if (ts.UseMediaStartTimestampInScheduler == false) {
      delete this._viewColumns.vitsSom;
    } else {
      if ("vitsSom" in this._viewColumns == false) {
        this.addPropertyAtSpecificLocation(10, "vitsSom", true); // 10 is the index in the grid columns
      }
    }
    this.populateViewColumns();
  }

  private addPropertyAtSpecificLocation(newIndex, newKey, newValue) {
    this._viewColumns = Object.keys(this._viewColumns).reduce(
      (result, key, index) => {
        if (index === newIndex) {
          result[newKey] = newValue;
        }
        result[key] = this._viewColumns[key];
        return result;
      },
      {},
    );
  }
  private populateViewColumns() {
    localStorage.setItem(
      this.VIEW_COLUMNS_STORAGE_KEY,
      JSON.stringify(this._viewColumns),
    );
    this.ViewColumns.next(this._viewColumns);
  }
}
